import React, { useState, useEffect } from "react";
import { Outlet, NavLink, Navigate, useNavigate } from "react-router-dom";
import BaseLayout from "../../layout/BaseLayout";
import "./compte.css";

// icons
import PersonIcon from "@mui/icons-material/Person";
import PortraitIcon from "@mui/icons-material/Portrait";
import LockResetIcon from "@mui/icons-material/LockReset";
import { getAbonneInfo_allRight } from "../../services/abonne/AbonneRequest";
import LoadingPage from "../loading-page/LoadingPage";
import { isAuthenticated } from "../../utils/AuthGuard";

const Compte = () => {
  const [user, setUser] = useState({});

  const AuthGuard = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [fetchingData, setFetchingData] = useState(true);
    const [showPromo, setShowPromo] = useState(false);

    useEffect(() => {
      const customerNumber = sessionStorage.getItem("customer_number")
        ? sessionStorage.getItem("customer_number")
        : "";
      getAbonneInfo_allRight(customerNumber)
        .then((res) => {
          setFetchingData(false);
          setUser(res.data.donnee);
          if (res.data.donnee.promo) {
            setShowPromo(true);
          } else {
            setShowPromo(false);
          }
        })
        .catch((err) => {
          console.log("api error", err);
        });
    }, []);

    return isAuthenticated() &&
      sessionStorage.getItem("token") &&
      user &&
      user.motdepasseisactif ? (
      <>
        <Outlet />
        {showPromo ? (
          <div className="toast">
            <div className="alert bg-white shadow-2xl border border-gray-300">
              <div className="relative sm:w-96 flex flex-col items-start">
                <button
                  className="btn btn-sm btn-circle absolute -right-1 -top-1"
                  onClick={() => setShowPromo(false)}
                >
                  ✕
                </button>
                <h2 className="text-left font-bold">Promotion 🎉🥳</h2>
                <p>{user.promo}</p>
              </div>
            </div>
          </div>
        ) : null}
      </>
    ) : !isAuthenticated() &&
      sessionStorage.getItem("token") &&
      user &&
      user.motdepasseisactif ? (
      <>
        <Navigate to="/password-access" />
      </>
    ) : isAuthenticated() &&
      sessionStorage.getItem("token") &&
      user &&
      !user.motdepasseisactif ? (
      <>
        {user && !user.motdepasseisactif ? (
          <>{sessionStorage.removeItem("token")}</>
        ) : null}
        <Outlet />
        {showPromo ? (
          <div className="toast">
            <div className="alert bg-white shadow-2xl border border-gray-300">
              <div className="relative sm:w-96 flex flex-col items-start">
                <button
                  className="btn btn-sm btn-circle absolute -right-1 -top-1"
                  onClick={() => setShowPromo(false)}
                >
                  ✕
                </button>
                <h2 className="text-left font-bold">Promotion 🎉🥳</h2>
                <p>{user.promo}</p>
              </div>
            </div>
          </div>
        ) : null}
      </>
    ) : !sessionStorage.getItem("token") && user && user.motdepasseisactif ? (
      <>
        <Navigate to="/password-access" />
      </>
    ) : !sessionStorage.getItem("token") && user && !user.motdepasseisactif ? (
      <>
        <Outlet />
        {showPromo ? (
          <div className="toast">
            <div className="alert bg-white shadow-2xl border border-gray-300">
              <div className="relative sm:w-96 flex flex-col items-start">
                <button
                  className="btn btn-sm btn-circle absolute -right-1 -top-1"
                  onClick={() => setShowPromo(false)}
                >
                  ✕
                </button>
                <h2 className="text-left font-bold">Promotion 🎉🥳</h2>
                <p>{user.promo}</p>
              </div>
            </div>
          </div>
        ) : null}
      </>
    ) : (
      <>
        <Outlet />
        {showPromo ? (
          <div className="toast">
            <div className="alert bg-white shadow-2xl border border-gray-300">
              <div className="relative sm:w-96 flex flex-col items-start">
                <button
                  className="btn btn-sm btn-circle absolute -right-1 -top-1"
                  onClick={() => setShowPromo(false)}
                >
                  ✕
                </button>
                <h2 className="text-left font-bold">Promotion 🎉🥳</h2>
                <p>{user.promo}</p>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  };

  return (
    <BaseLayout>
      <div className="h-fit">
        <div className="grid-layout w-full h-full">
          <div className="sidebar-menu h-full bg-gray-mtn flex justify-end border-r border-gray-300">
            <div className="bg-gray-mtn w-full md:w-3/5 h-full">
              <div className="menu-desktop pt-10">
                <NavLink to="/compte/profil">
                  <div className="border-b-2 border-b-white/50 py-5 px-6">
                    <p className="text-lg text-gray-700 font-medium">
                      My profil
                    </p>
                  </div>
                </NavLink>
                {/* <NavLink to="/compte/detail">
                  <div className="border-b-2 border-b-white/50 py-5 px-6">
                    <p className="text-lg text-gray-700 font-medium">Account</p>
                  </div>
                </NavLink> */}
                {/* {(user && user.motdepasseisactif) ? <NavLink to="/compte/password">
                  <div className="border-b-2 border-b-white/50 py-5 px-6">
                    <p className="text-lg text-gray-700 font-medium">Mot de passe</p>
                  </div>
                </NavLink> : null} */}
                {/* <NavLink to="/compte/history">
                  <div className="border-b-2 border-b-white/50 py-5 px-6">
                    <p className="text-lg text-gray-700 font-medium">
                      Historiques
                    </p>
                  </div>
                </NavLink> */}
              </div>
              <div className="menu-mobile">
                <NavLink to="/compte/profil">
                  <div className="border-b-2 border-b-white/50 h-16 w-full flex items-center justify-center">
                    <PersonIcon sx={{ fontSize: 28 }} />
                  </div>
                </NavLink>
                {/* <NavLink to="/compte/detail">
                  <div className="border-b-2 border-b-white/50 h-16 w-full flex items-center justify-center">
                    <PortraitIcon sx={{ fontSize: 28}} />
                  </div>
                </NavLink> */}
                {/* {(user && user.motdepasseisactif) ? <NavLink to="/compte/password">
                  <div className="border-b-2 border-b-white/50 h-16 w-full flex items-center justify-center">
                    <LockResetIcon sx={{ fontSize: 28}} />
                  </div>
                </NavLink> : null} */}
              </div>
            </div>
          </div>
          <div className="main-content h-full bg-white">
            <AuthGuard />
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default Compte;
